export default __webpack_public_path__ + "static/media/the_pope_video_de.29be47dd.svg";